import Swiper from 'swiper';

const instances = new WeakMap();

export function initBubKachelElements(scope = document) {
	for (const element of scope.querySelectorAll('[data-bub-kachel-element]')) {
		if (instances.has(element)) continue;
		const viewport = element.querySelector('.bub-kachel-element__viewport');
		const wrapper = element.querySelector('.bub-kachel-element__tiles');
		const pagination = element.querySelector('.bub-kachel-element__pagination');
		const tiles = [...wrapper.children];
		if (tiles.length < 2) continue;

		const mobile = window.matchMedia('(max-width: 991.98px)');
		const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
		let slider;
		let buttons = [];
		let previousButton;
		let nextButton;

		const updatePosition = () => {
			buttons.forEach((button, index) => {
				button.classList.toggle('active', index === slider.activeIndex);
				button.setAttribute(
					'aria-current',
					String(index === slider.activeIndex),
				);
			});
			previousButton.disabled = slider.isBeginning;
			nextButton.disabled = slider.isEnd;
		};

		const updateLayout = () => {
			if (mobile.matches && !slider) {
				viewport.scrollLeft = 0;
				viewport.classList.add('bub-kachel-element__viewport--slider');
				slider = new Swiper(viewport, {
					wrapperClass: 'bub-kachel-element__tiles',
					slideClass: 'bub-kachel-element__tile',
					slidesPerView: 1,
					spaceBetween: 24,
					loop: false,
					speed: reducedMotion.matches ? 0 : 300,
					watchOverflow: true,
					touchStartPreventDefault: false,
				});
				buttons = tiles.map((tile, index) => {
					const button = document.createElement('button');
					button.type = 'button';
					button.className = 'bub-kachel-element__dot textslider-dot';
					const title = tile
						.querySelector('.bub-kachel-element__title')
						?.textContent.trim();
					button.setAttribute(
						'aria-label',
						`Kachel ${index + 1} von ${tiles.length}${title ? `: ${title}` : ''}`,
					);
					button.addEventListener('click', () =>
						slider.slideTo(index, reducedMotion.matches ? 0 : 300),
					);
					return button;
				});
				const dots = document.createElement('div');
				dots.className = 'bub-kachel-element__dots textslider-dots';
				dots.append(...buttons);
				const createArrow = (direction, label, symbol) => {
					const button = document.createElement('button');
					button.type = 'button';
					button.className = `bub-kachel-element__arrow textslider-arrow textslider-arrow-${direction}`;
					button.setAttribute('aria-label', label);
					button.textContent = symbol;
					return button;
				};
				previousButton = createArrow('prev', 'Vorherige Kachel', '‹');
				nextButton = createArrow('next', 'Nächste Kachel', '›');
				previousButton.addEventListener('click', () =>
					slider.slidePrev(reducedMotion.matches ? 0 : 300),
				);
				nextButton.addEventListener('click', () =>
					slider.slideNext(reducedMotion.matches ? 0 : 300),
				);
				pagination.replaceChildren(previousButton, dots, nextButton);
				pagination.hidden = false;
				slider.on('slideChange', updatePosition);
				updatePosition();
			} else if (!mobile.matches && slider) {
				slider.destroy(true, true);
				slider = undefined;
				viewport.classList.remove('bub-kachel-element__viewport--slider');
				pagination.replaceChildren();
				pagination.hidden = true;
				buttons = [];
			}
		};

		viewport.addEventListener('keydown', (event) => {
			if (!slider || event.target !== viewport) return;
			const speed = reducedMotion.matches ? 0 : 300;
			if (event.key === 'ArrowRight') slider.slideNext(speed);
			else if (event.key === 'ArrowLeft') slider.slidePrev(speed);
			else return;
			event.preventDefault();
		});
		mobile.addEventListener('change', updateLayout);
		instances.set(element, { updateLayout });
		updateLayout();
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => initBubKachelElements(), {
		once: true,
	});
} else {
	initBubKachelElements();
}
